import { HiOutlineChevronDown } from "react-icons/hi";
import { FIELD_STATE, isRequiredFieldState } from "../../utils";

const SelectInput = ({ fieldState, value, onChange, placeholder, options, hasError = false, disabled = false, inRow = false, ...rest }) => {
  const stringValue = value ?? "";
  const hasValue = stringValue !== "";
  const isRequired = isRequiredFieldState(fieldState);

  if (fieldState === FIELD_STATE.DISABLE) return null;

  const isRequiredEmpty = isRequired && !hasValue;

  return (
    <div className={inRow ? "relative flex-1" : "relative"} {...rest}>
      <select
        value={stringValue}
        onChange={onChange}
        className={`field-input appearance-none py-1 pl-2 pr-7${hasValue ? "" : isRequiredEmpty ? " text-orange-400" : " text-gray-300"}`}
        data-state={hasError ? "error" : isRequiredEmpty ? "required" : undefined}
        disabled={disabled}
      >
        <option value="">{placeholder ? `Sélectionner ${placeholder.toLowerCase()}` : "—"}</option>
        {(options || []).map(({ value: optionValue, label }) => (
          <option key={optionValue} value={optionValue}>
            {label}
          </option>
        ))}
      </select>
      <HiOutlineChevronDown className={`pointer-events-none absolute right-2 top-1/2 h-3.5 w-3.5 -translate-y-1/2 ${isRequiredEmpty ? "text-orange-400" : "text-gray-400"}`} />
    </div>
  );
};

export default SelectInput;
